import React, { Fragment, PureComponent } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { Toastr, tools } from 'data/common';
import { withRouter } from 'react-router-dom';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FHEContainer } from 'data/components';
import { getBoxDetails, updateBoxDetails } from '../../../data/Boxes/actions';
import { FormBox } from '../forms';
import getSelectors from '../selectors';

class HomeBox extends PureComponent {
    static propTypes = {
        homeBoxExists: PropTypes.bool.isRequired,
        homeBoxMac: PropTypes.string,
        getBoxDetails: PropTypes.func.isRequired,
        updateBoxDetails: PropTypes.func.isRequired,
        isActive: PropTypes.bool.isRequired
    };
    static defaultProps = {
        homeBoxMac: null
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: props.isActive && props.homeBoxExists,
            needGetData: props.isActive && props.homeBoxExists,
            fetching: false,
            initialized: false,
            error: null
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { needGetData, loading, error, fetching, initialized } = state;
        const { isActive, homeBoxExists } = props;

        if (!initialized && isActive && !needGetData && !loading && !error && !fetching && homeBoxExists)
            return { needGetData: true, loading: true };
        return null;
    }

    componentDidMount() {
        const { isActive, homeBoxExists } = this.props;
        if (isActive && homeBoxExists) this.getBoxDetails();
    }

    componentDidUpdate() {
        const { isActive } = this.props;
        const { needGetData, fetching, error, initialized } = this.state;
        if (!initialized && isActive && needGetData && !fetching && !error) {
            this.getBoxDetails();
        }
    }

    getBoxDetails = () => {
        const { getBoxDetails, homeBoxMac } = this.props;
        this.state.needGetData = false;
        this.state.fetching = true;
        getBoxDetails(homeBoxMac)
            .then(() => this.setState({ error: null, loading: false, needGetData: false, fetching: false, initialized: true }))
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ error: message, loading: false, needGetData: false, fetching: false, initialized: false });
            });
    };
    retryGetData = () => {
        this.setState({ error: null, loading: true, needGetData: true });
    };

    renderChildren = () => {
        const { isActive, updateBoxDetails } = this.props;

        return (
            <Fragment>
                <FormBox type="update" isActive={isActive} sendDataFunc={updateBoxDetails} />
            </Fragment>
        );
    };
    render() {
        const { error, loading } = this.state;

        return <FHEContainer hasNoClassContainer loading={loading} error={error} onClickFunc={this.retryGetData} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);
    const homeBox = selectors.getBoxByHomeId(state, homeId);
    return {
        homeBoxMac: homeBox.get('macAddress'),
        homeBoxExists: homeBox.size > 0
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/sections/HomeBox',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getBoxDetails, updateBoxDetails }), dispatch)
        )(HomeBox)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/sections/HomeBox.js